import type React from "react";
import { useSelector } from "react-redux";
import type { RootState } from "../store";
import { fetchCustomers } from "../store/features/customerSlice";
import CustomerTable from "../components/customers/CustomerTable";
import CreateCustomerForm from "../components/customers/CreateCustomerForm";
import { createCustomerApi, updateCustomerApi } from "../api/customersApi";
import SimpleCrudPage from "../components/common/SimpleCrudPage";
import { canMutateCustomers } from "../types/user";
import { TestId } from "../constants/testIds";

const CustomersPage: React.FC = () => {
  const user = useSelector((state: RootState) => state.user.user);

  return (
    <SimpleCrudPage
      titleTranslationKey="customers.title"
      addButtonTranslationKey="Add Customer"
      fetchAction={fetchCustomers}
      createApi={createCustomerApi}
      updateApi={updateCustomerApi}
      selector={(state: RootState) => ({
        items: state.customers.customers,
        loading: state.customers.loading,
      })}
      createErrorContext="createCustomer"
      updateErrorContext="updateCustomer"
      createSuccessMessage="Customer created successfully"
      updateSuccessMessage="Customer updated successfully"
      TableComponent={CustomerTable}
      FormComponent={CreateCustomerForm}
      canMutate={canMutateCustomers(user)}
      addButtonTestId={TestId.CUSTOMER.ADD_BUTTON}
    />
  );
};

export default CustomersPage;
